import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';

import {VtToasterService, VtToastMessage} from '@services/vt-toaster.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-vt-toaster',
    templateUrl: './vt-toaster.component.html',
    styleUrls: ['./vt-toaster.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass]
})
export class VtToasterComponent implements OnInit {

  vtToastMessages: VtToastMessage[] = [];

  constructor(
    private readonly vtToasterService: VtToasterService,
    private readonly cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.vtToasterService.vtToastMessages$.subscribe(messages => {
      this.vtToastMessages = messages;
      this.cdr.markForCheck();
    });
  }

  getIconClass(type: string): string {

    switch (type) {
      case 'success':
        return 'fa fa-check-circle';
      case 'error':
        return 'fa fa-times-circle';
      default:
        return '';
    }
  }

  closeToast(vtToastMessage: VtToastMessage) {
    this.vtToasterService.removeToast(vtToastMessage);
  }

}
